import React, { useEffect } from 'react';
import { IdRegistration, Project, Status } from 'src/common/types';
import { useFetch } from 'src/hooks/useFetch';

interface ProjectProps {
  registration: IdRegistration;
  opdrachtgever: string;
  updateRegistration: (name: string, value: string | number | Project | undefined) => void;
}

export const ProjectComponent = ({ registration, opdrachtgever, updateRegistration }: ProjectProps) => {
  const { data: projects, setUrl: setProjectUrl } = useFetch<Project[]>('', {
    defaultValue: [],
  });

  useEffect(() => {
    setProjectUrl(`/api/project?opdrachtgever=${opdrachtgever}`);
  }, [opdrachtgever, setProjectUrl]);

  const updateProject = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const project = projects.find(pr => pr.id === event.target.value);
    updateRegistration('project', project);
  };

  return (
    <>
      {registration.status !== Status.MIGRATED ? (
        <div className="property">
          <label htmlFor="project_id">Project</label>
          <select id="project_id" value={registration.project?.id || ''} onChange={updateProject}>
            <option value="">Geen project</option>
            {projects.map((option, index) => (
              <option key={index} value={option.id}>
                {option.project_number}
              </option>
            ))}
          </select>
        </div>
      ) : null}
    </>
  );
};
